// import React from 'react';
// import { Route, Redirect } from 'react-router-dom';
// // import Cookies from 'js-cookie';
// const OtpRoute = ({ component: Component, ...rest }) => {
//   const accessToken = localStorage.getItem("accessToken");
//   const tfaEnabled = localStorage.getItem("tfaEnabled");
//   const otpVerified = localStorage.getItem("otpVerified");
//   // const accessToken = Cookies.get('accessToken');
//   // const tfaEnabled = Cookies.get('tfaEnabled');
//   // const otpVerified = Cookies.get('otpVerified');
// console.log("otp route")
//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         accessToken && tfaEnabled && !otpVerified ? (
//           <Component {...props} />
//         ) : (
//           <Redirect to={otpVerified ? "/changepassword" : "/"} />
//         )
//       }
//     />
//   );
// };

// export default OtpRoute;
import React, { useState, useEffect } from 'react';
import { Route, Redirect, useLocation, useHistory } from 'react-router-dom';

const OtpRoute = ({ component: Component, ...rest }) => {
  const [redirectToOtp, setRedirectToOtp] = useState(false); // Manage redirection state
  const accessToken = localStorage.getItem("accessToken");
  const tfaEnabled = localStorage.getItem("tfaEnabled");
  const otpVerified = localStorage.getItem("otpVerified");

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    // If we are not on the OTP page and need to redirect, set the flag to true
    if (location.pathname !== '/otp' && accessToken && tfaEnabled && !otpVerified) {
      setRedirectToOtp(true); // Trigger redirection flag
    }
  }, [location.pathname, accessToken, tfaEnabled, otpVerified]);

  useEffect(() => {
    console.log("otp route")
    // Perform redirection only if flag is set and no redirection has occurred
    if (redirectToOtp) {
      history.push('/otp');
      setRedirectToOtp(false); // Reset the flag after redirection
    }
  }, [redirectToOtp, history]);

  return (
    <Route
      {...rest}
      render={(props) =>
        accessToken && tfaEnabled && !otpVerified ? (
          <Component {...props} />
        ) : (
          <Redirect to={otpVerified ? "/dashboard" : "/login"} />
        )
      }
    />
  );
};

export default OtpRoute;
